
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import ControlLabel from './control-label'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "controllabel"
    }}>{`ControlLabel`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Controls`}</p>
    <hr />
    <h2 {...{
      "id": "label"
    }}>{`Label`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For providing additional information about a control or control content.`}</p>
    <Playground __position={1} __code={'<ControlLabel text=\"Label\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlLabel
    }} mdxType="Playground">
  <ControlLabel text="Label" mdxType="ControlLabel" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "label-inverse"
    }}>{`Label (inverse)`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For providing additional information about a control or control content.`}</p>
    <Playground __position={3} __code={'<ControlLabel text=\"Label\" inverse />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlLabel
    }} style={{
      backgroundColor: '#333',
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <ControlLabel text="Label" inverse mdxType="ControlLabel" />
    </Playground>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={ControlLabel} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;